<template lang="pug">
  a(:href="url")
    slot
</template>

<script>
import { WEBSITE_LANDING_BASE_URL, BUILD_MODE } from '~/settings'

export default {
  name: 'LandingLink',

  props: {
    path: {
      type: String,
      default: '',
      required: true
    }
  },

  computed: {
    url () {
      const env = {
        production: 'production',
        staging: 'staging',
        autotest: 'staging',
        local: 'local',
        dev: 'dev'
      }[BUILD_MODE]

      const url = new URL(this.path, WEBSITE_LANDING_BASE_URL)

      if (env !== 'production')
        url.searchParams.set('env', env)

      return url.href
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
